module.exports = __webpack_public_path__ + "static/media/wedding2.af52745c.jpg";